module.exports = __webpack_public_path__ + "../resources/img/ic_re_play_dark.7fc9e59b.svg";